import { InputAnimatedLabel } from '@web/components/ui/input-animated-label';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@web/components/ui/dropdown-menu';
import { ChevronDownIcon } from 'lucide-react';

type ProcedureStatusDropdownProps = {
  value?: string;
  readOnly?: boolean;
  onSelect: (status: 'Active' | 'Inactive') => void;
};

export function ProcedureStatusDropdown({
  value,
  readOnly = true,
  onSelect,
}: ProcedureStatusDropdownProps) {
  const statusOptions: ('Active' | 'Inactive')[] = ['Active', 'Inactive'];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={readOnly}>
        <div className="relative w-full">
          <InputAnimatedLabel
            label="Status"
            value={value ?? ''}
            readOnly={true}
            className={readOnly ? '' : 'border-2 border-blue-500'}
          />
          {!readOnly && (
            <ChevronDownIcon className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500" />
          )}
        </div>
      </DropdownMenuTrigger>
      {!readOnly && (
        <DropdownMenuContent className="rounded-lg border bg-white shadow-lg">
          {statusOptions.map((status) => (
            <DropdownMenuItem
              key={status}
              onSelect={() => {
                onSelect(status);
              }}
              className="cursor-pointer px-4 py-2 hover:bg-gray-100"
            >
              {status}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      )}
    </DropdownMenu>
  );
}
